module.exports = __webpack_public_path__ + "img/bg_1@2x.5fb14aee.png";